import { StandardProps } from "../../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { GalleryTeaserUI } from "./GalleryTeaserUI";

type GalleryProps = Pick<StandardProps, "product" | "configProps" | "flags">;

export const GalleryTeaser = ({ product, configProps }: GalleryProps) => {
  const { variant } = useVariant(product);
  const openModalOnClick = configProps?.openModalOnClick === true;

  return (
    <GalleryTeaserUI
      product={product}
      variant={variant}
      openModalOnClick={openModalOnClick}
    />
  );
};
